import React, { useEffect, useRef } from 'react';
import Icon from '../AppIcon';
import OnXMessageBubble from './OnXMessageBubble';
import { ONX_AVATAR } from './OnXHeader';
import useTranslation from '../../hooks/useTranslation';

/**
 * Zone des messages (la seule qui defile). Descend en bas a chaque nouveau
 * message, a l'attente d'une reponse et a l'affichage d'une erreur.
 */
const OnXMessageList = ({ messages, isLoading, error }) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages, isLoading, error]);

  return (
    <div ref={containerRef} className="flex-1 min-h-0 overflow-y-auto px-6 py-4">
      <div className="max-w-[800px] mx-auto">
        {messages.map((msg, i) => (
          <OnXMessageBubble key={`${msg?.role}-${msg?.timestamp ?? i}`} message={msg} />
        ))}

        {/* OnX reflechit */}
        {isLoading && (
          <div className="flex items-start gap-2.5 mb-4">
            <img
              src={ONX_AVATAR}
              alt=""
              aria-hidden="true"
              draggable={false}
              className="w-8 h-8 rounded-full object-cover flex-shrink-0 select-none"
            />
            <div className="bg-muted rounded-2xl rounded-bl-sm px-4 py-3 flex items-center gap-2">
              <span className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
              </span>
              <span className="text-xs text-muted-foreground">{t('onx.typing')}</span>
            </div>
          </div>
        )}

        {error && (
          <div className="flex items-start gap-2 text-xs text-red-600 bg-red-50 rounded-lg px-3.5 py-2.5 mb-4">
            <Icon name="AlertCircle" size={14} className="mt-0.5 flex-shrink-0" />
            <span>{t('onx.errorGeneric')}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OnXMessageList;
